module.exports = __webpack_public_path__ + "static/media/logo_farmRio_white.8daf1f81.svg";